import type { PointArray } from '../types/contour-definition-array-type';

import { kinks, unkinkPolygon } from '@turf/turf';

import { convertArrayToPointArray } from './convertArrayToPointArray';

import { getBiggestPolygon, pointArrayToPolygon } from './turf-utils';

export function removeLoops(pointArray: PointArray): PointArray {
  if (pointArray.length < 3) {
    return pointArray;
  }
  const convertedPolygon = pointArrayToPolygon(pointArray);
  const hasKinksInitial = kinks(convertedPolygon);

  if (!(hasKinksInitial.features?.length > 0)) {
    return pointArray;
  }

  const intersectionsArr = unkinkPolygon(convertedPolygon);

  const allPolygons = intersectionsArr.features.map(
    feature => feature.geometry,
  );

  const biggestPolygon = getBiggestPolygon(allPolygons);

  const noLoopsArray = biggestPolygon.coordinates[0];

  return convertArrayToPointArray(noLoopsArray);
}
